import { useAuth0 } from '@auth0/auth0-react'
import { useCallback } from 'react'

import LockOpenIcon from '@mui/icons-material/LockOpen'
import type { ButtonProps } from '@mui/material/Button'
import Button from '@mui/material/Button'
import Skeleton from '@mui/material/Skeleton'

import { useLocation } from '../../router/hooks/useLocation'

export const LoginButton = ({ ...rest }: ButtonProps) => {
  const { isLoading, loginWithRedirect } = useAuth0()
  const { pathname } = useLocation()

  const handleLogin = useCallback(async () => {
    await loginWithRedirect({
      appState: {
        returnTo: pathname || '/',
      },
    })
  }, [loginWithRedirect, pathname])

  if (isLoading) {
    return (
      <Skeleton variant="circular" width={20} height={20} sx={{ m: '10px' }} />
    )
  }

  return (
    <Button
      onClick={handleLogin}
      startIcon={<LockOpenIcon />}
      variant="text"
      {...rest}
    >
      Inloggen
    </Button>
  )
}
